import React from "react";
import { Box, Button } from "@mui/material";

interface StickyFooterButtonsProps {
  onEditClick: () => void;
  onBackClick: () => void;
  onSaveClick?: () => void;        // ✅ Used in Save button
  onGenerateClick?: () => void;
  isEditMode: boolean;
  isSaveMode?: boolean;
  isSaveDisabled?: boolean;
  isDeleteDisabled?: boolean;
  onDeleteClick?: () => void;
}

const StickyFooterButtons: React.FC<StickyFooterButtonsProps> = ({
  onEditClick,
  onBackClick,
  onSaveClick,
  onGenerateClick,
  isEditMode,
  isSaveMode = false,
  isSaveDisabled = false,
  isDeleteDisabled = false,
  onDeleteClick,
}) => {
  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        backgroundColor: "#fff",
        padding: "10px 20px",
        display: "flex",
        justifyContent: "flex-end",
        zIndex: 1000,
      }}
    >
      {isSaveMode ? (
        <Button
          variant="contained"
          onClick={onSaveClick}     // ✅ Call the passed function
          disabled={isSaveDisabled}
          sx={{ mr: 2 }}
        >
          Save
        </Button>
      ) : (
        <>
          <Button
            variant="contained"
            color="primary"
            onClick={onEditClick}
            sx={{ mr: 2 }}
          >
            {isEditMode ? "Update" : "Edit"}
          </Button>

          {onDeleteClick && (
            <Button
              variant="outlined"
              color="error"
              onClick={onDeleteClick}
              disabled={isDeleteDisabled}
              sx={{ mr: 2 }}
            >
              Delete
            </Button>
          )}
        </>
      )}

      {onGenerateClick && (
        <Button
          variant="contained"
          color="secondary"
          onClick={onGenerateClick}
          sx={{ mr: 2 }}
        >
        Generate
        </Button>
      )}

      <Button variant="outlined" onClick={onBackClick}>
        Back
      </Button>
    </Box>
  );
};

export default StickyFooterButtons;